import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const engagementResolver: FieldResolver = (metadata: Metadata) =>
  ({ engagement: metadata.getEngagement() } as StreamData)

export default engagementResolver
